import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { isAdminRole } from "../../context/authUser";

export default function AdminOnly({ children }: any) {
  const { appUser, loading } = useAuth();
  const isAdmin = isAdminRole(appUser?.role);

  if (loading) return null;
  if (!isAdmin) return <Navigate to="/schedule" replace />;

  return children;
}
